import { BalanceReport } from '@src/pages/ticketRestaurant/index';

const BalanceGiftReport = () => {
  return <BalanceReport isCompliments={true} />;
};

export default BalanceGiftReport;
